module.exports = __webpack_public_path__ + "img/free.9eaaf526.jpg";